<template>
    <div class="casesCennert">
        <div class="casesCennert_cennert">
            <ul class="cal" id="cal">
                   
                <li 
                     @click="panopticSort(index)"
                    v-for="(item,index) in Navigation"
                    :key="index"
                    :class="{calsh:index == panopticSort_index}"
                >
                    {{item}}
                </li>
            </ul>
            <ul class="cal_list">
                <div class="bgloading" v-if="logi">
                    <div class="loading3">
                        <div class="circle circle1">
                            <span></span>
                            <span></span>
                            <span></span> 
                            <span></span>
                        </div>
                        <div class="circle circle2">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div class="circle circle3">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <li v-for="(item,index) in dataLists" :key="index"
                   @mouseover="pop1(item,index)" 
                   @mouseleave="pop2(item)"
                   @click="Product_Click(item)"
                >
                  <div data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back"
                        data-aos-delay="0"
                        data-aos-offset="10">
                    <div class="cal_list_top">
                        <img
                            :src="item.img"
                        />
                            <div class="top" v-if="cal_tf && indcal_tf === index"  >
                                <div class="clickplay_qj"></div>
                                <div class="erweima" >
                                    <div id="qrcode_max">
                                        <div id="qrcode" ref="qrcode" >
                                                <div class="qrcode_Mask"></div>
                                        </div>
                                        <div class="qrcode_btn">
                                            点击进入
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="cal_list_bottom" >
                        <h3>{{item.title}}</h3>
                        <p>{{item.des}}</p>
                    </div>
</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
    data() {
        return {
        cal_tf:false,
        indcal_tf:null,
        VR_display:false,
        link:null,
        panopticSort_index:0,
        // 防止重复加载
        Navigation:["线上展厅","VR实拍复刻","模板展厅","3D建模","全景直播","VR房产","元宇宙画展"],
        dataLists:"",
        // 下拉加载精品案例的索引
        ind0:1,
        // 下拉加载线上展厅的索引
        ind1:1,
        // 下拉模板展厅索引
        ind2:1,
        // 下拉3D模板展厅索引
        ind3:1,
        // 下拉加载直播的索引
        ind4:1,
        // 下拉加载房产的索引
        ind5:1,
        // 下拉加载房产的索引
        ind6:1,
        a:false,
        logi:false
        }
    },
   
    methods:{
        pop1(e,e1){
            if(e.link=='' || e.link==null){
                return false;
            }else{
                 this.cal_tf = true
            this.indcal_tf = e1;
                this.$nextTick(() => {
                    this.qrcode(e.link);
                })
            }
        
        },
        pop2(){
            this.cal_tf = false
        },
        qrcode(link) {
            document.getElementById("qrcode").innerHTML = "";
            let qrcode = new QRCode("qrcode", {
                width: 110, // 设置宽度，单位像素
                height: 110, // 设置高度，单位像素
                text:link // 设置二维码内容或跳转地址
            });
        },
        Product_Click(link1){
            let link_1 = link1;
            if(link_1.link=='' || link_1.link==null){
                return false;
            }else{
                this.$emit('handleChange', link_1) // 触发父组件中handleChange事件并传参Jack
            }
        },
        close(){
            this.VR_display = false
        },
        // 封装请求下拉加载
        MX_data(ind,url,cate,cate2){
                        this.$axios.post(
                        url,
                        this.$qs.stringify({
                            page:ind,
                            cate:cate, 
                        }),    
                        )
                        .then(res => {
                            this.a = false
                                 if(res.data.code == 500){
                                 }else{
                                    var nextdata = res.data.data 
                                    for(var i = 0 ;i<nextdata.length;i++){
                                            nextdata[i].img = "http://oss.3dyunchuang.com/home_pic/vrgif/"+nextdata[i].img +"."+nextdata[i].type 
                                            if( nextdata[i].cate == "model"){
                                                //  nextdata[i].like = "https://3dyunchuang.com/" + "static/upmodel/models/" + nextdata[i].link
                                            }
                                            if(nextdata[i].cate == "video"){

                                            }
                                            if(cate2 != ""){
                                                nextdata[i].cate2  = "allcate";
                                            }
                                        }    
                                    var ne = this.dataLists.concat(nextdata)
                                    this.dataLists = ne  
                                 }
                        })
        },
        
        //当下拉的时候 触发MX_data
        Drop_downloading(){
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var windowHeitht = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            // 是否滚动到底部的判断
            if(scrollTop + windowHeitht+560>= scrollHeight){
            clearTimeout(this.tiemID);//防抖
            this.tiemID = setTimeout(() => {
                
                        // //下拉精品
                        // if(this.panopticSort_index == 0){
                        //     this.ind0++
                        //     this.MX_data(this.ind0,"https://www.3dyunchuang.com/api/test/Indexsugg2","","allcate")
                        // }
                        //下拉展厅
                        if(this.panopticSort_index == 0){
                             this.ind1++
                             this.MX_data(this.ind1,"https://www.3dyunchuang.com/api/test/GetCateInfo2",1,"")
                        }
  

                        
                        //下拉实拍
                        if(this.panopticSort_index == 1){
                            this.ind4++
                            this.MX_data(this.ind4,"https://www.3dyunchuang.com/api/test/GetCateInfo2",19,"")
                        }

                            //下拉模板展厅
                        if(this.panopticSort_index == 2){
                             this.ind2++
                             this.MX_data(this.ind2,"https://www.3dyunchuang.com/api/test/GetCateInfo2",5,"")
                        }

                        //下拉3d建模
                        if(this.panopticSort_index == 3){
                             this.ind3++
                             this.MX_data(this.ind3,"https://www.3dyunchuang.com/api/test/GetCateInfo2",4,"")
                        }
                        //下拉全景
                        if(this.panopticSort_index == 4){
                            this.ind4++
                            this.MX_data(this.ind4,"https://www.3dyunchuang.com/api/test/GetCateInfo2",3,"")
                        }


                        //下拉房产
                        if(this.panopticSort_index == 5){
                            this.ind5++
                             this.MX_data(this.ind5,"https://www.3dyunchuang.com/api/test/GetCateInfo2",2,"")
                        }

                         //下拉房产
                        if(this.panopticSort_index == 6){
                            this.ind6++
                             this.MX_data(this.ind6,"https://www.3dyunchuang.com/api/test/GetCateInfo2",22,"")
                        }
            }, 300);      
            } 
        },
        // 切换内容
        receive_data(url,cate,page,cate2){
                     this.$axios.post(
                        url,
                        this.$qs.stringify({
                            cate:cate,
                            page:page,           
                        }),    
                        )
                        .then(res => {
                            this.dataLists  = ""
                               this.dataLists =  res.data.data     
                                        for(var i = 0 ;i<this.dataLists.length;i++){
                                            this.dataLists[i].img = "http://oss.3dyunchuang.com/home_pic/vrgif/"+this.dataLists[i].img +"."+this.dataLists[i].type 
                                            if( this.dataLists[i].cate == "model"){            
                                            }
                                            if(this.dataLists[i].cate == "video"){
                                            }
                                            if(cate2 != ""){
                                                this.dataLists[i].cate2  = "allcate";
                                            }
                                        }     
                                    this.logi = true
                                    var thi_s = this
                                    setTimeout(function(){
                                        thi_s.logi = false
                                    },600) 
                        })
        },
        panopticSort(index){
            this.panopticSort_index = index
            this.ind = 1
            this.ind1 = 1
            this.ind2 = 1
            this.ind3 = 1
            this.ind4 = 1
            var thi_s = this

            // //点击了精品案例
            // if(this.panopticSort_index == 0){
            //     this.receive_data("https://www.3dyunchuang.com/api/test/Indexsugg2","",0,"allcate")
            // }
            //点击了线上展厅
            if(this.panopticSort_index == 0){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",1,0,"")
            }

           //点了VR实拍
            if(this.panopticSort_index == 1){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",19,0,"")
            }

            //点击了模板展厅
            if(this.panopticSort_index == 2){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",5,0,"")
            
            }
            //点击了3D建模
            if(this.panopticSort_index == 3){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",4,0,"")
            }
            // //点击了全景直播
            if(this.panopticSort_index ==4){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",3,0,"")
            }
         
            // 点击了VR看房
            if(this.panopticSort_index == 5){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",2,0,"")
            }

             if(this.panopticSort_index == 6){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",22,0,"")
            }
        }
    },
    mounted(){
        // this.$route.query.goid实在首页跳转而来
        // 加载全部数据
        if(this.$route.query.goid == undefined){
                this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",1,0,"")
        }

        if(this.$route.query.goid == 'cal' || this.$route.query.goid == 0){
             this.panopticSort_index = 0
              this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",1,0,"")
        }
        if(this.$route.query.goid == 1){
            this.panopticSort_index = 1
            this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",19,0,"")
        }
       if(this.$route.query.goid == 2){
            this.panopticSort_index = 2
            this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",5,0,"")
        }
        if(this.$route.query.goid == 'modeling' || this.$route.query.goid == 3){
            this.panopticSort_index = 3
            this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",4,0,"")
        }
        if(this.$route.query.goid == 'LiveBroad' || this.$route.query.goid == 4){
             this.panopticSort_index = 4
             this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",3,0,"")
        }
        if(this.$route.query.goid == 'houseProperty' || this.$route.query.goid == 5){
             this.panopticSort_index = 5
                   this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",2,0,"")
        }
        if(this.$route.query.goid == 6){
             this.panopticSort_index = 6
            this.receive_data("https://www.3dyunchuang.com/api/test/GetCateInfo2",22,0,"")
        }


        window.addEventListener('scroll',this.Drop_downloading)
    },
    destroyed () {
        window.removeEventListener('scroll',this.Drop_downloading)
    },
}
</script>
<style scoped>
.if{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background:rgba(25,25,25,0.95);
}
.casesCennert{
    width: 100%;
    height: 100%;
    background: #f9f9f9;
}
.casesCennert_cennert{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
    position: relative;
}
.cal{
    width: 1040px;
    height: 42px;
    padding-top: 40px;
    margin: 0px auto 40px ;
}
.cal li{
    width: 129px;
    height: 100%;
    float: left;
    margin-right: 20px;
    line-height: 42px;
    text-align: center;
    border-radius: 30px;
    cursor: pointer;
}
.calsh{
     color: #fff;
     background: #1a7cf8;
}
.cal li:nth-child(5){
    margin: 0px;
}
.cal_list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    min-height: 600px;
}
.cal_list:after{
        content:'';
        /*这个宽度和子元素宽度一致*/
        width: 363px;
        height: 0;
        display: block;
    }

.cal_list li{
    width: 363px;
    height: 354px;
    /* background: #ffffff; */
    float: left;
    margin-bottom: 57px;
    transition: 0.5s  all;
    cursor: pointer;
}
.cal_list li:hover{
    -webkit-box-shadow: #ccc 0px 10px 10px;
    -moz-box-shadow: #ccc 0px 10px 10px;
    box-shadow: #ccc 0px 10px 10px; 
}
.cal_list_top{
    height: 210px;
    width: 100%;
    position: relative;
}
.cal_list_top img{
    width: 100%;
    height: 100%;
}
.erweima {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  cursor: pointer;
}
#qrcode{
  margin: 0 auto;
  position: relative;
  width: 109px; 
  height: 112px;
  z-index: 2;
  overflow: hidden;
  padding: 5px 5px 4px 5px;
  background: #fff;
  margin-top: 25px;
  margin-bottom: 11px;
}
.qrcode_Mask{
    width: 100%;
    background: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
}
.qrcode_btn{
    text-align: center;
    width: 95px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;
    margin: 0 auto;
}
.cal_list_bottom{
    padding: 29px 30px 14px 20px;
    width: 312px;
    height: 100px;
    background: #fff;
}
.cal_list_bottom h3{
    margin-bottom: 10px;
}
.cal_list_bottom p{
    font-size: 15px;
    color: #656565;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient:vertical;
}
.VR_style{
  width: 1352px;
  height: 803px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 999;
  background: #fff;
  padding: 15px 15px 15px 15px;
  transform: translate(-50%,-50%);
  border-radius: 10px;
  z-index: 1;
  position: relative;
 
}
#iframe{
  width: 100%;
  height: 100%;
  opacity: 0.8;
  transition: 1s all; 
   border-radius: 10px;
}
.close{
  width: 40px;
  height: 37px;
  background: red;
  position: absolute;
  right: -64px;
  top:-34px;
  z-index: 999;
  background: url("../../assets/imges/close.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

/* 加载条代码 */
.loader {
    background: #000;
    background: radial-gradient(#222, #000);
    overflow: hidden;
    z-index: 99999;
    overflow: hidden;
    position: absolute;
    left: 15px;
    top: 15px;
 width: 1352px;
  height: 803px;
    border-radius: 10px;
}

.loader-inner {
    bottom: 0;
    height: 60px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}

.loader-line-wrap {
    animation: 
		spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite
	;
    box-sizing: border-box;
    height: 50px;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    transform-origin: 50% 100%;
    width: 100px;
}
.loader-line {
    border: 4px solid transparent;
    border-radius: 100%;
    box-sizing: border-box;
    height: 100px;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}
.loader-line-wrap:nth-child(1) { animation-delay: -50ms; }
.loader-line-wrap:nth-child(2) { animation-delay: -100ms; }
.loader-line-wrap:nth-child(3) { animation-delay: -150ms; }
.loader-line-wrap:nth-child(4) { animation-delay: -200ms; }
.loader-line-wrap:nth-child(5) { animation-delay: -250ms; }

.loader-line-wrap:nth-child(1) .loader-line {
    border-color: hsl(0, 80%, 60%);
    height: 90px;
    width: 90px;
    top: 7px;
}
.loader-line-wrap:nth-child(2) .loader-line {
    border-color: hsl(60, 80%, 60%);
    height: 76px;
    width: 76px;
    top: 14px;
}
.loader-line-wrap:nth-child(3) .loader-line {
    border-color: hsl(120, 80%, 60%);
    height: 62px;
    width: 62px;
    top: 21px;
}
.loader-line-wrap:nth-child(4) .loader-line {
    border-color: hsl(180, 80%, 60%);
    height: 48px;
    width: 48px;
    top: 28px;
}
.loader-line-wrap:nth-child(5) .loader-line {
    border-color: hsl(240, 80%, 60%);
    height: 34px;
    width: 34px;
    top: 35px;
}
.clickplay_qj{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    opacity: 0;
}
@keyframes spin {
    0%, 15% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}

  .bgloading{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0px;
      z-index: 99;
      background: #f9f9f9;
  }
  .loading3{
            width:30px;
            height:30px;
            position: absolute;
            left: 50%;
            top: 20%;
            transform: translate(-50%,-50%);
        }
        .circle{
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
        }
        .circle span{
            width:8px;
            height:8px;
            display:inline-block;
            background:#357eff;
            border-radius: 100%;
            position:absolute;
            -webkit-animation: mycircle 1.2s infinite ease-in-out;
            animation: mycircle 1.2s infinite ease-in-out;
            -webkit-animation-fill-mode:both;
            animation-fill-mode:both;
        }
       .circle2{
           -webkit-transform: rotateZ(45deg);
           transform: rotateZ(45deg);
       }
       .circle3{
           -webkit-transform: rotateZ(90deg);
           transform: rotateZ(90deg);
       }
       .circle>span:nth-child(1){
            top:0;
            left:0;
       }
       .circle>span:nth-child(2){
            top:0;
            right:0;
       }
       .circle>span:nth-child(3){
            right:0;
            bottom:0;
       }
       .circle>span:nth-child(4){
            left:0;
            bottom:0;
       }
       .circle2 >span:nth-child(1){
            -webkit-animation-delay: -1.1s;
            animation-delay: -1.1s;
       }
       .circle3 >span:nth-child(1){
            -webkit-animation-delay: -1.0s;
            animation-delay: -1.0s;
       }
       .circle1 >span:nth-child(2){
            -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s;
       }
       .circle2 >span:nth-child(2){
            -webkit-animation-delay: -0.8s;
            animation-delay: -0.8s;
       }
       .circle3 >span:nth-child(2){
            -webkit-animation-delay: -0.7s;
            animation-delay: -0.7s;
       }
       .circle1 >span:nth-child(3){
            -webkit-animation-delay: -0.6s;
            animation-delay: -0.6s;
       }
       .circle2 >span:nth-child(3){
            -webkit-animation-delay: -0.7s;
            animation-delay: -0.7s;
       }
       .circle3 >span:nth-child(3){
            -webkit-animation-delay: -0.4s;
            animation-delay: -0.4s;
       }
       .circle1 >span:nth-child(4){
            -webkit-animation-delay: -0.3s;
            animation-delay: -0.3s;
       }
       .circle2 >span:nth-child(4){
            -webkit-animation-delay: -0.2s;
            animation-delay: -0.2s;
       }
       .circle3 >span:nth-child(4){
            -webkit-animation-delay: -0.1s;
            animation-delay: -0.1s;
       }
       @-webkit-keyframes mycircle{
            0%{transform:scale(0.0);}
            40%{transform:scale(1.0);}
            80%{transform:scale(0.0);}
            100%{transform:scale(0.0);}
        }
        @keyframes mycircle{
            0%{transform:scale(0.0);}
            40%{transform:scale(1.0);}
            80%{transform:scale(0.0);}
            100%{transform:scale(0.0);}
        }
/****FIN CERCLE****/

</style>


// WEBPACK FOOTER //
// src/common/cases/cases-cennert.vue